import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

const stats = [
  { value: "128", label: "追踪中事件" },
  { value: "76", label: "已核实事件" },
  { value: "2,400+", label: "收录依据条目" },
  { value: "24h", label: "更新响应" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/topics?q=${encodeURIComponent(q)}` : "/topics");
  };

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20investigative%20dossier%20scene%20with%20scattered%20documents%20magnifying%20glass%20and%20evidence%20markers%20on%20deep%20charcoal%20desk%2C%20warm%20amber%20and%20vermillion%20light%20accents%2C%20cinematic%20moody%20lighting%2C%20soft%20grain%2C%20high%20detail%2C%20dramatic%20composition&width=1600&height=900&seq=kodo-hero-01&orientation=landscape"
        alt="散布着文件与放大镜的证据核查工作台氛围图"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/80 to-foreground-950/40" />

      <div className="relative mx-auto w-full max-w-[1280px] px-4 py-16 md:px-6 md:py-24">
        <p className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 font-label text-xs text-background-100">
          <i className="ri-shield-check-line" /> 证据链追踪 · 真假辨析 · 可信度标注
        </p>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          蝌蚪爆料
          <span className="mt-3 block text-xl font-semibold text-accent-200 md:text-3xl">
            实锤追踪 · 石锤证据对比
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          把散落在转发里的截图、录音与声明整理成一条可追溯的证据链，
          标注每一项依据的强度与来源，并给出可信度参考。争议信息里，先看依据，再做判断。
        </p>

        <form onSubmit={handleSubmit} className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row" role="search">
          <div className="flex flex-1 items-center gap-2 rounded-md border border-background-50/25 bg-background-50/10 px-3 py-3 backdrop-blur focus-within:border-accent-300">
            <i className="ri-search-line text-sm text-background-200" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="search"
              placeholder="输入事件关键词，例如「录音」「截图对比」"
              aria-label="搜索爆料事件"
              className="w-full bg-transparent text-sm text-background-50 outline-none placeholder:text-background-300"
            />
          </div>
          <button
            type="submit"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            开始追踪 <i className="ri-arrow-right-line" />
          </button>
        </form>

        <dl className="mt-12 grid grid-cols-2 gap-6 border-t border-background-50/20 pt-8 md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label}>
              <dt className="font-label text-xs text-background-300">{s.label}</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-accent-200 md:text-3xl">
                {s.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}